/**
 * Tablet kiosk scroll lives on `.naturals-salon-lux__content` (see
 * NaturalsKioskTabletFooter.css), not on individual page roots. Welcome /
 * code / face screens leave that shell scrolled to the Proceed CTA + footer;
 * reset it on route change so hub (and other pages) open at the top.
 */
export function resetNaturalsSalonLuxScroll(contentEl) {
  const shell =
    contentEl ||
    (typeof document !== 'undefined'
      ? document.querySelector('.naturals-salon-lux__content')
      : null);

  if (typeof window !== 'undefined') {
    window.scrollTo(0, 0);
  }
  if (typeof document !== 'undefined') {
    document.documentElement.scrollTop = 0;
    document.body.scrollTop = 0;
  }

  if (shell) {
    shell.scrollTop = 0;
    shell.scrollLeft = 0;
  }

  if (typeof document === 'undefined') return;

  document.querySelectorAll('.fi-scroll-page, .salon-flow-select-page, .naturals-pres-hub').forEach((el) => {
    el.scrollTop = 0;
    el.scrollLeft = 0;
  });
  document.querySelector('.salon-flow-select-consent-scroll')?.scrollTo?.(0, 0);
}
